import { ReactNode } from "react";
import { FileObjectType } from "@jsq/ds/core";
import { BaseDocumentType } from "../../../graphql/supergraphTypes";

/**
 * Document sub type enum, these are strings that are used to identify the type of document
 */
export enum DocumentSubTypeEnum {
  ArticlesOfIncorporation = "articles_of_incorporation",
  LimitedPartnership = "limited_partnership_operating_agreement",
  CertificateOfFormation = "certificate_of_formation",
  CertificateOfIncorporation = "certificate_of_incorporation",
  CertificateOfFormOrPartnership = "certificate_of_formation_partnership",
}

/**
 * Modal types for document collection confirmation dialogs
 */
export enum DocumentModalTypeEnum {
  NO_DOCS_AVAILABLE = "no-docs-available",
  GUEST_MISSING_DOCS = "guest-missing-docs",
}

/**
 * Document subtype type, these are strings that are used to identify the type of document
 */
export type DocumentSubType =
  | "articles_of_incorporation"
  | "limited_partnership_operating_agreement"
  | "certificate_of_formation"
  | "certificate_of_incorporation"
  | "certificate_of_formation_partnership";

/**
 * These are the data that are used to display the document category info
 */
export type DocumentData = {
  id?: number;
  file: FileObjectType | null;
  uploaderInfo?: string | null;
  baseType: BaseDocumentType;
  subType: string | null;
  meta?: { profileId: number | undefined };
  expiryDate?: string | null;
  createdAt?: string | null;
  modifiedAt?: string | null;
  lastUploadedDate?: string;
};

/**
 * Strings that are used to display the document category info
 */
export type DocumentCategoryInfo = {
  title: string;
  description: string | ReactNode;
};

/**
 * Document form props type, these are the data that are used to display the document category info
 */
export type DocumentFormProps = DocumentCategoryInfo & DocumentData;

export type DocumentInvitedUserInfo = {
  emailAddress: string;
  id: number;
  uploadDate?: string;
};

export interface DocumentCollectorProps {
  /**
   * Identification document category
   */
  documentDetails: DocumentFormProps[];

  isSubmitting: boolean;

  buttonConfig?: {
    label: string;
    showNoDocumentsTT?: boolean;
  };

  /**
   * Whether to show skip upload option
   * Defaults to false. Set to true for guest document collection scenarios.
   */
  allowSkipToUpload?: boolean;

  /**
   * Handler for back button click
   */
  onNavigateBack?: () => void;

  /**
   * Handler for complete button click
   */
  onComplete: (newFiles: DocumentData[], deleteDocIds: number[]) => void;

  /**
   * Callback to notify parent component about unsaved changes
   */
  onUnsavedChangesChange?: (hasChanges: boolean) => void;

  /**
   * Callback to notify parent component when all documents are ready (have files attached)
   */
  onAllDocumentsReadyChange?: (allReady: boolean) => void;

  /**
   * Optional callback to handle canceling upload invite
   * If not provided, the component will handle it internally
   */
  preUploadCallback?: () => void;

  /**
   * Information about the person who invited the guest to upload documents
   * Used to display personalized messages in guest upload scenarios
   */
  inviterInfo?: {
    name: string;
    email: string;
  };
}
